import HomeFilters from "./HomeFilters";
import StatusJobList from "./StatusJobs";
import ReportsPanel from "../Reports/ReportsPanel"; // ⭐ NEW IMPORT
function MiddleContent({ candidateId, activeStatus, employeeId, dateFilter, refreshSummary }) {
  return (
    <div className="middle-panel">
      {activeStatus === "HOME" ? (
        <HomeFilters candidateId={candidateId} employeeId={employeeId} dateFilter={dateFilter} refreshSummary={refreshSummary}
        />
      ) : activeStatus === "REPORTS" ? (
        
        <ReportsPanel 
          candidateId={candidateId}
          employeeId={employeeId}
        />

      ) : (
        <StatusJobList candidateId={candidateId} status={activeStatus} employeeId={employeeId} dateFilter={dateFilter}
        />
      )}
    </div>
  );
}

export default MiddleContent;
